/**
 * DEV-1021. Строки для материалов ЖК и бейджа агентских комментариев.
 * Подмешиваются поверх базовых локалей через deepMerge (см. locales/index.ts).
 */
export const dev1021Messages = {
  ru: {
    properties: {
      materials: {
        title: 'Материалы',
        loading: 'Загрузка материалов…',
        empty: 'Материалы не загружены',
        pickFile: 'Выберите файл',
        fieldTitle: 'Название',
        fieldCategory: 'Категория',
        fieldLocale: 'Язык',
        localeAny: 'Без языка',
        upload: 'Загрузить',
        uploadSuccess: 'Материал загружен',
        uploadError: 'Не удалось загрузить материал',
        download: 'Скачать',
        delete: 'Удалить',
        confirmDelete: 'Удалить этот материал?',
        deleteSuccess: 'Материал удалён',
        deleteError: 'Не удалось удалить материал',
        categories: {
          presentation: 'Презентация',
          brochure: 'Брошюра',
          priceList: 'Прайс-лист',
          floorPlan: 'Планировка',
          documents: 'Документы',
          creative: 'Креативы',
        },
        locales: { ru: 'Русский', en: 'English', vn: 'Tiếng Việt' },
      },
    },
    deals: {
      comments: {
        agentBadge: 'Агент',
        agentAuthor: 'Агент',
      },
    },
  },
  en: {
    properties: {
      materials: {
        title: 'Materials',
        loading: 'Loading materials…',
        empty: 'No materials uploaded',
        pickFile: 'Choose a file',
        fieldTitle: 'Title',
        fieldCategory: 'Category',
        fieldLocale: 'Language',
        localeAny: 'No language',
        upload: 'Upload',
        uploadSuccess: 'Material uploaded',
        uploadError: 'Failed to upload material',
        download: 'Download',
        delete: 'Delete',
        confirmDelete: 'Delete this material?',
        deleteSuccess: 'Material deleted',
        deleteError: 'Failed to delete material',
        categories: {
          presentation: 'Presentation',
          brochure: 'Brochure',
          priceList: 'Price list',
          floorPlan: 'Floor plan',
          documents: 'Documents',
          creative: 'Creatives',
        },
        locales: { ru: 'Русский', en: 'English', vn: 'Tiếng Việt' },
      },
    },
    deals: {
      comments: {
        agentBadge: 'Agent',
        agentAuthor: 'Agent',
      },
    },
  },
  vn: {
    properties: {
      materials: {
        title: 'Tài liệu',
        loading: 'Đang tải tài liệu…',
        empty: 'Chưa có tài liệu',
        pickFile: 'Chọn tệp',
        fieldTitle: 'Tiêu đề',
        fieldCategory: 'Danh mục',
        fieldLocale: 'Ngôn ngữ',
        localeAny: 'Không có ngôn ngữ',
        upload: 'Tải lên',
        uploadSuccess: 'Đã tải tài liệu lên',
        uploadError: 'Không thể tải tài liệu lên',
        download: 'Tải xuống',
        delete: 'Xóa',
        confirmDelete: 'Xóa tài liệu này?',
        deleteSuccess: 'Đã xóa tài liệu',
        deleteError: 'Không thể xóa tài liệu',
        categories: {
          presentation: 'Bài thuyết trình',
          brochure: 'Brochure',
          priceList: 'Bảng giá',
          floorPlan: 'Mặt bằng',
          documents: 'Tài liệu',
          creative: 'Ấn phẩm',
        },
        locales: { ru: 'Русский', en: 'English', vn: 'Tiếng Việt' },
      },
    },
    deals: {
      comments: {
        agentBadge: 'Đại lý',
        agentAuthor: 'Đại lý',
      },
    },
  },
}
